import styled from 'styled-components'
export const Wrapper = styled.div`
  .icon-size {
    width: 24px;
    height: 24px;
  }
`
